export default {
  vipUpgrade: {
    title: 'おめでとうございます!!',
    message: 'VIP{from}からVIP{to}へ昇格しました',
    subtitle: 'ご支援ありがとうございます。新しいレベルでは\n限定サービスと特別特典をご利用いただけます。',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
